<template>
  <rh-etapa-card
    titulo="Documentação e Contato"
    subtitulo="CPF, RG, CTPS, e-mail e telefone"
    icone="mdi-card-account-details-outline"
  >
    <ValidationObserver ref="obs" tag="div">
      <v-row>
        <v-col cols="12" md="3" class="pt-0 pb-0">
          <ValidationProvider name="CPF" rules="required|cpf" v-slot="{ errors }">
            <e-label>Número do CPF <span class="red--text">*</span></e-label>
            <v-text-field
              v-mask="'###.###.###-##'"
              v-model="form.pessoal.cpf"
              :error-messages="errors"
              dense
              solo
            />
          </ValidationProvider>
        </v-col>

        <v-col cols="12" md="3" class="pt-0 pb-0">
          <e-label>Nº do Registro Geral (RG)</e-label>
          <v-text-field v-model="form.pessoal.rg" dense solo v-mask="'#############'" />
        </v-col>

        <v-col cols="12" md="3" class="pt-0 pb-0">
          <e-label>CTPS (Carteira de Trabalho)</e-label>
          <v-text-field v-model="form.pessoal.ctps" dense solo placeholder="Nº da CTPS" />
        </v-col>

        <v-col cols="12" md="3" class="pt-0 pb-0">
          <e-label>Série CTPS</e-label>
          <v-text-field v-model="form.pessoal.serie" dense solo placeholder="Série da CTPS" />
        </v-col>

        <v-col cols="12" md="6" class="pt-0 pb-0">
          <e-label>Email</e-label>
          <v-text-field v-model="form.pessoal.email" dense solo />
        </v-col>

        <v-col cols="12" md="6" class="pt-0 pb-0">
          <e-label>Telefone</e-label>
          <v-text-field v-model="form.pessoal.telefone" v-mask="'(##) #####-####'" dense solo />
        </v-col>
      </v-row>
    </ValidationObserver>

    <rh-documentos-secao
      categoria="documentacao"
      titulo="Documentos de identificação"
      subtitulo="Ex.: CPF, RG, CNH, CTPS."
      :itens="documentos"
      v-on="$listeners"
    />
  </rh-etapa-card>
</template>

<script>
import RhEtapaCard from "../components/RhEtapaCard.vue";
import RhDocumentosSecao from "../components/RhDocumentosSecao.vue";

export default {
  name: "EtapaDocumentacaoContato",
  components: { RhEtapaCard, RhDocumentosSecao },
  props: {
    form: { type: Object, required: true },
    documentos: { type: Array, default: () => [] },
  },
  methods: {
    validar() {
      return this.$refs.obs.validate();
    },
  },
};
</script>
